export const lastUpdated = 'Dec. 16, 2022 at 6:03 p.m.';

export const articlesASE = [

  'Recognition',
  'Appointment notification',
  'Appointment security',
  'Child care',
  'Classifications',
  'Class sizes',
  'Community safety',
  'Defined contribution and university retirement plans',
  'Definitions',
  'Discipline and dismissal',
  'Emergency layoff',
  'Employment files and evaluations',
  'Fee remission',
  'Grievance and arbitration',
  'Health and safety',
  'Health benefits',
  'Holidays',
  'Housing',
  'International scholars and immigrant support',
  'Labor management meetings',
  'Leaves',
  'Management and academic rights',
  'No strikes',
  'Nondiscrimination in employment',
  'Parking and transit',
  'Peer-led trainings',
  'Posting',
  'Reasonable accommodations',
  // 'Access needs side letter',
  'Relocation benefit',
  'Respectful work environment',
  'Past practices',
  'Severability',
  'Summer session',
  'Training and orientation',
  'Travel',
  'Union access and rights',
  'Union security',
  'Wages',
  'Wages side letter',
  'Waiver',
  'Workload',
  'Workspace materials and instructional support',
  'Duration',
  'Preamble',
  'Ground rules',
  'Appendix F',
  'Appendix YY',
  'Joint labor management committee',
  'Berkeley staffing side letter',
  'Summer funding side letter',
  'Off-scale payments side letter',
  'Extension of previous contract',
];

const recognitionProposals = [

  {
    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/17MhRsD1_E1yPJMFLTjIB1iLaO6FmhTo2/view?usp=sharing',
    color: 'success',
  },

];

const appointmentNotificationProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 7, 2022',
  //   link: 'https://drive.google.com/file/d/1kINGZWQAtplW13IGpCWmUsn3dvFtQr0E/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | April 19, 2022',
  //   link: 'https://drive.google.com/file/d/16ZH2QbUi0E4_Fx457nKbf8NEwdYdWeAO/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | April 26, 2022',
  //   link: 'https://drive.google.com/file/d/1MWCI68wDnjqiiozGgymYWI4H69yAHo1Y/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | May 17, 2022',
  //   link: 'https://drive.google.com/file/d/1u_XKgCEASILSq47oXABYbFORAJluQIDR/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 10, 2022',
  //   link: 'https://drive.google.com/file/d/1GnYrwHH3lIVhh-7r_PNoFlj4avc9rkPu/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | July 17, 2022',
  //   link: 'https://drive.google.com/file/d/1DaZdYZP-KD_P73sAe-yxF73EYhrbYZ0B/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | August 16, 2022',
  //   link: 'https://drive.google.com/file/d/1_0LBmJQs48kPW6d0fNv0E0ywEEdImIj0/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1ZcIK5iv2k-m-kkzX-oJor8Omko-DbYJ_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1EC_ZbKhkWHIG6i6IbHXTvvYtq2Lit09g/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1xxjVDOItF-y4_1ikxbfP8vNXxYXGeoVd/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 21, 2022',
  //   link: 'https://drive.google.com/file/d/1lBXmKPOcGDHF_GEm6UJR7VwTzQhjkxsK/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/11A2ZNAxRBTi8uV1SjDLlZjbEmNQbwLv1/view?usp=sharing',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 29, 2022',
    link: 'https://drive.google.com/file/d/1hJFL80mfqNarZ0hfPMjUW1cAmWaQ9iTj/view?usp=sharing',
    color: 'success',
  },

];

const appointmentSecurityProposals = [

  {
    name: 'Tentative agreement | June 2, 2022',
    link: 'https://drive.google.com/file/d/15OysSNi8MgtVzNSw9HFjKCFQimb4cipw/view?usp=sharing',
    color: 'success',
  },

];

const childCareProposals = [

  // {
  //   name: 'Proposal | UAW to UC | March 16, 2022',
  //   link: 'https://drive.google.com/file/d/1n6S4CfXG0i2zGHOc_wpqssHHDWkepfGT/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/11chbKuLDDR5N8GIhWtkKAmik7_Dze4t8/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1n572TTGkWppefvjWzN6qhlPHqOy6thrt/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/16FpLKmQG1RGGh9MxUzO1iWlN49Pzq4ss/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1WofzmrOi-VV0K7YSbglGyl1LHfUFDAZN/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1Zh0Ibmw1OHBeQKhTztTm0zMzRW1nRI-m/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/1Xd0otd243uGz3Kmdn_v5of2aqjsx5iQP/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1TAiRZ_9RSEtczC9qAnr-QUja_JfaRKu3/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1RhGBN4suCp3khxPfUE2JbKClvcYrVnt-/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Supposal | UC to UAW | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1WYO9q5usNYWTRTfBRsMBEMVvUb02Tily/view',
    color: 'success',
  },

];

const classificationsProposals = [

  {
    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1faQ-GG3lGy52C2klcAEvwRem5O3fgjx7/view?usp=sharing',
    color: 'success',
  },

];

const classSizesProposals = [

  // {
  //   name: 'Proposal | UAW to UC | March 31, 2022',
  //   link: 'https://drive.google.com/file/d/1c2FY3C5tOP-droQ48w34DM_cfgEnYCEJ/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | May 24, 2022',
  //   link: 'https://drive.google.com/file/d/1TKsMbgn9BykHA38J7dMWBLFVWZfzId6v/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1EivjcVp3k5GS0W24sBUOCALR_j_qjv8Q/view?usp=sharing',
  //   color: 'secondary',
  // },

];

const communitySafetyProposals = [

  {
    name: 'Proposal | UAW to UC | Sept. 21, 2022',
    link: 'https://drive.google.com/file/d/103xbSowGfFVICduoKvravDOZuAVDBHHV/view?usp=sharing',
    color: 'secondary',
  },

];

const retirementProposals = [

  {
    name: 'Tentative agreement | Oct. 17, 2022',
    link: 'https://drive.google.com/file/d/16HAiJCYnkSwCcO5pEf-bEbml5MxKSVyg/view?usp=sharing',
    color: 'success',
  },

];

const definitionsProposals = [

  {
    name: 'Tentative agreement | March 16, 2022',
    link: 'https://drive.google.com/file/d/1Wc5Sb2AwFIWkgeXBgD7z1cxGTr-duKPy/view?usp=sharing',
    color: 'success',
  },

];

const disciplineProposals = [

  {
    name: 'Tentative agreement | June 17, 2022',
    link: 'https://drive.google.com/file/d/114pVQ59v6u_9ORASL-izscyGnf7IEDH4/view?usp=sharing',
    color: 'success',
  },

];

const emergencyLayoffProposals = [

  {
    name: 'Tentative agreement | March 16, 2022',
    link: 'https://drive.google.com/file/d/1Wc5Sb2AwFIWkgeXBgD7z1cxGTr-duKPy/view?usp=sharing',
    color: 'success',
  },

];

const filesProposals = [

  {
    name: 'Tentative agreement | April 19, 2022',
    link: 'https://drive.google.com/file/d/19vIEmaxqHmF2yYcIY0O8h13SdcAWuTlO/view?usp=sharing',
    color: 'success',
  },

];

const feeRemissionProposals = [
  // {
  //   name: 'Proposal | UAW to UC | March 16, 2022',
  //   link: 'https://drive.google.com/file/d/1LAS0-YF1j0WA_l41qlghhInkIcw4mec0/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1n572TTGkWppefvjWzN6qhlPHqOy6thrt/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1vguaStxxIfoBX0SexE1_34SiiaFoymnK/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Aug. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1NLFLPjUTi_LB-_pvJz1ebfvBctKktcjU/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1WvprGdAb3xiV2wUKPiIR13V6DQoQNJ7M/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1WofzmrOi-VV0K7YSbglGyl1LHfUFDAZN/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Oct. 19, 2022',
  //   link: 'https://drive.google.com/file/d/1_sRgbE2xZyyY2LBhS562n-PJu2ighJro/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Oct. 27, 2022',
  //   link: 'https://drive.google.com/file/d/1toZ6FQexuw8cn5jXvvs7iDMFrACMGuwY/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/1nlQEynfoCJCJEZGq71TziV4lTVxx18gN/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-TLFwkLfo3FyXuyedL_7dKXpiCRKcyz9/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1TAiRZ_9RSEtczC9qAnr-QUja_JfaRKu3/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/11Ac6sDkHIhcBe80aZkg5Ey0k6plymede/view',
    color: 'success',
  },

];

const grievanceProposals = [

  {
    name: 'Tentative agreement | Nov. 11, 2022',
    link: 'https://drive.google.com/file/d/17ObnkgdQJSqjlsi3h6d8dSoy1YdS3KC0/view?usp=sharing',
    color: 'success',
  },

];

const healthSafetyProposals = [

  {
    name: 'Tentative agreement | April 19, 2022',
    link: 'https://drive.google.com/file/d/1fh5nh54DuDz7WrrMDuFtAysUEUsLEN-x/view?usp=sharing',
    color: 'success',
  },

];

const healthBenefitsProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 19, 2022',
  //   link: 'https://drive.google.com/file/d/1EqB5yOPzaV3k864TXSZx9jWsvJiVfP-7/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1kQY7cfquPLAh1uIcIYhMclS_XbFe_nj-/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1n572TTGkWppefvjWzN6qhlPHqOy6thrt/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1WofzmrOi-VV0K7YSbglGyl1LHfUFDAZN/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/1lVDG1vYoc9QxL2PQcp7Tyw6t3vwu_zks/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-TLFwkLfo3FyXuyedL_7dKXpiCRKcyz9/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1AirRFJ-bI73KghkvWlcTPZODd3cSa4lx/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1QNyTeGPUjrZDkuM4QDpGPHEqaTuIO64t/view?usp=sharing',
    color: 'success',
  },

];

const holidaysProposals = [

  {
    name: 'Tentative agreement | March 2, 2022',
    link: 'https://drive.google.com/file/d/1ALyGozP-bWA7n0ZJpy5F1eLttNIvzcnr/view?usp=sharing',
    color: 'success',
  },

];

const housingProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 7, 2022',
  //   link: 'https://drive.google.com/file/d/1D-e7lZ2iMo-DF9ksdbd9cydHCtr9-LDD/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 21, 2022',
  //   link: 'https://drive.google.com/file/d/1uRHteFgxRts0zm6bLzGvIFBIUNhxMXju/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/135xYYj_yD9ux1E4pKsdGG2miqWUBxGIO/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },

];

const internationalProposals = [

  {
    name: 'Tentative agreement | Nov. 22, 2022',
    link: 'https://drive.google.com/file/d/1MqFSfIXa-WiDDPP_DUE3mESVY7U_5BR2/view',
    color: 'success',
  },

];

const laborManagementProposals = [

  {
    name: 'Tentative agreement | March 16, 2022',
    link: 'https://drive.google.com/file/d/1Wc5Sb2AwFIWkgeXBgD7z1cxGTr-duKPy/view?usp=sharing',
    color: 'success',
  },

];

const leavesProposals = [

  // {
  //   name: 'Proposal | UAW to UC | March 16, 2022',
  //   link: 'https://drive.google.com/file/d/1KUAlDA4OxAH5D_iAsgBKSPILzBsaGjV_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1NR1_rMD_Z4dtk4IUIwEPQuulNdIGkwAM/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1n572TTGkWppefvjWzN6qhlPHqOy6thrt/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1YQBN19fursB0digva4cMYieErpUnwgMS/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1sPk-SIhWq7C23XSdB4WHZmW2J7jhrBNZ/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1WofzmrOi-VV0K7YSbglGyl1LHfUFDAZN/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 9, 2022',
  //   link: 'https://drive.google.com/file/d/1Rodd93g2w-6mAzTSCPZ1OS1lHSiXp_vL/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 2, 2022',
    link: 'https://drive.google.com/file/d/1MGQF-HGru9yqBLTbsSmweNAeyR2q0L4e/view',
    color: 'success',
  },

];

const academicRightsProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 7, 2022',
  //   link: 'https://drive.google.com/file/d/1vNHGVquKleO8E0jZUE50MIKijs7gqHcv/view?usp=sharing',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 8, 2022',
    link: 'https://drive.google.com/file/d/1PZ1ImJl8Lx42AS5tSelmERZqHw19ecjM/view?usp=share_link',
    color: 'success',
  },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/1UpuqYx_WHwJ9bE6cdnlYgkIsk9ECXM58/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },
];

const noStrikesProposals = [

  // {
  //   name: 'Proposal | UAW to UC | March 31, 2022',
  //   link: 'https://drive.google.com/file/d/1Pyb7H3WjjFZhkNVtWTITwa6X7K5zekX0/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | April 19, 2022',
  //   link: 'https://drive.google.com/file/d/18uXIBLQmdLgT3IforL943NQ3QhyMxIJI/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | March 31, 2022',
  //   link: 'https://drive.google.com/file/d/19W06HXmN1NZbBsA23VVFKUpKRD2WE2Sm/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | April 19, 2022',
  //   link: 'https://drive.google.com/file/d/1-TLFwkLfo3FyXuyedL_7dKXpiCRKcyz9/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 2, 2022',
    link: 'https://drive.google.com/file/d/19W06HXmN1NZbBsA23VVFKUpKRD2WE2Sm/view',
    color: 'success',
  },

];

const nondiscriminationProposals = [

  {
    name: 'Tentative agreement | Sept. 28, 2022',
    link: 'https://drive.google.com/file/d/1JfcgcuhUDBQ16cFOfY0ZcTcNnwqP9CD-/view?usp=sharing',
    color: 'success',
  },

];

const parkingTransitProposals = [

  // {
  //   name: 'Proposal | UAW to UC | April 19, 2022',
  //   link: 'https://drive.google.com/file/d/13nU7Tlois7D0ttGCE2pdtGCaV3vlMoK4/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1aXM8nQudZz13U9fDWKGcKCHeFhrf6ers/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1n572TTGkWppefvjWzN6qhlPHqOy6thrt/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1A0verhKzOmwnbdT9vyCXKfrxYdvp47XH/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1WofzmrOi-VV0K7YSbglGyl1LHfUFDAZN/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 22, 2022',
  //   link: 'https://drive.google.com/file/d/1gR7bC3Crbvrtca5evyu8ybu2u6qMmP7s/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1-hjfc3646L14gtT0FSGruvfVp1Bybxdy/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1mhDgaWe6RAOJ6H4HchuhjpfUsr0jGCwY/view?usp=sharing',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/1N3WOxwtXOhDYeLOcbtnlnjz-ZDaHHvGU/view?usp=sharing',
    color: 'success',
  },

];

const peerLedTrainingProposals = [

  // {
  //   name: 'Proposal | UAW to UC | March 31, 2022',
  //   link: 'https://drive.google.com/file/d/1v2Zfnd3IM7Fv9dPNvAdS2hjAUJ2nnFS3/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },

];

const postingProposals = [

  {
    name: 'Tentative agreement | April 19, 2022',
    link: 'https://drive.google.com/file/d/1vE_g5i7rjQ0y5ljDh4SW4vyF_F24mc1Y/view?usp=sharing',
    color: 'success',
  },

];

const reasonableAccommodationsProposals = [

  // {
  //   name: 'Proposal | UAW to UC | March 31, 2022',
  //   link: 'https://drive.google.com/file/d/1_FKPugcLv1mxwBHTGIFafm0mrAgCBntS/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | April 26, 2022',
  //   link: 'https://drive.google.com/file/d/1OTyX7zOHeftrR5QbAD6SzkuKWNoPY5VT/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | May 17, 2022',
  //   link: 'https://drive.google.com/file/d/14O8FIoHq9tesRjDjtsBg_J_looRZDmVd/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | July 12, 2022',
  //   link: 'https://drive.google.com/file/d/1j59w6QBGHEtDLBev3_fV3ABViIspHXuq/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 16, 2022',
  //   link: 'https://drive.google.com/file/d/14T5ba6nVVsds_dTRJqBgrJr9Keu3hjBA/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Aug. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1udulHPspihtwXBpC-SBTnxh1f8RjukFp/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1id9W2pJBbUUfIsibuqrxTmiuwD0HJ74i/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1ZcIK5iv2k-m-kkzX-oJor8Omko-DbYJ_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 9, 2022',
  //   link: 'https://drive.google.com/file/d/1m5Lx_xrRucTSOZaDiosJb2JVwZC768nB/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 9, 2022',
  //   link: 'https://drive.google.com/file/d/1CxCy1QAQzcSdZD3myvTRsQCfOiyJeZUW/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 10, 2022',
  //   link: 'https://drive.google.com/file/d/1EC_ZbKhkWHIG6i6IbHXTvvYtq2Lit09g/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/173rih7UUxJr5DOPSE6R5A4OdLVJPE1hR/view?usp=sharing',
    color: 'success',
  },

];

const accessNeedsProposals = [

  {
    name: 'Package | UC to UAW | Aug. 16, 2022',
    link: 'https://drive.google.com/file/d/1udulHPspihtwXBpC-SBTnxh1f8RjukFp/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Aug. 23, 2022',
    link: 'https://drive.google.com/file/d/125R9MPypqYK0xk7t4ehS8JYtyVsSvcBs/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Oct. 17, 2022',
    link: 'https://drive.google.com/file/d/1r9TcHp_ZMnrXkg3RfH43VCXvIaDOHeN1/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Oct. 17, 2022',
    link: 'https://drive.google.com/file/d/1ZcIK5iv2k-m-kkzX-oJor8Omko-DbYJ_/view?usp=sharing',
    color: 'secondary',
  },
  // FIGURE OUT

];

const relocationBenefitProposals = [

  // {
  //   name: 'Proposal | UAW to UC | May 24, 2022',
  //   link: 'https://drive.google.com/file/d/18SjvunOkL-2zDKaFwsHDOpnAo7OA9ba7/view?usp=sharing',
  //   color: 'secondary',

  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },

];

const respectfulProposals = [

  {
    name: 'Tentative agreement | Sept. 28, 2022',
    link: 'https://drive.google.com/file/d/1p6qmpqR4OZ3KrHlkEwL7FYMM1ZfpJl0Z/view?usp=sharing',
    color: 'success',
  },

];

const pastPracticesProposals = [];

const severabilityProposals = [

  {
    name: 'Tentative agreement | March 16, 2022',
    link: 'https://drive.google.com/file/d/1Wc5Sb2AwFIWkgeXBgD7z1cxGTr-duKPy/view?usp=sharing',
    color: 'success',
  },

];

const summerSessionProposals = [

  // {

  //   name: 'Proposal | UC to UAW | July 12, 2022',
  //   link: 'https://drive.google.com/file/d/1cKXOX36NlT4MHNNGTbvmjh3E_xlD9BHA/view?usp=sharing',
  //   color: 'secondary',

  // },
  // {

  //   name: 'Package | UC to UAW | Aug. 16, 2022',
  //   link: 'https://drive.google.com/file/d/1_0LBmJQs48kPW6d0fNv0E0ywEEdImIj0/view?usp=sharing',
  //   color: 'secondary',

  // },
  // {

  //   name: 'Package | UC to UAW | Sept. 21, 2022',
  //   link: 'https://drive.google.com/file/d/15VKaw8cfNraqokQyFA_1wuwn8hIy8GzQ/view?usp=sharing',
  //   color: 'secondary',

  // },
  // {

  //   name: 'Package | UC to UAW | Oct. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1bjnlIOdnD623-ri6G5EvcUcDBo3QISkI/view?usp=sharing',
  //   color: 'secondary',

  // },
  // {

  //   name: 'Proposal | UAW to UC | Oct. 19, 2022',
  //   link: 'https://drive.google.com/file/d/17w1M_k_qS_hQtwK7uaM-V4Ha7FbSZWb5/view?usp=sharing',
  //   color: 'secondary',

  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/16_aOXC-LwaLav6tCTtr9tsdaj5mrknc8/view?usp=sharing',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 29, 2022',
    link: 'https://drive.google.com/file/d/1mdUM9AVRPtT_7cvPZlnQN3MqiHyiqWso/view?usp=sharingg',
    color: 'success',
  },

];

const trainingOrientationProposals = [

  {
    name: 'Tentative agreement | June 28, 2022',
    link: 'https://drive.google.com/file/d/1yrwg1SufdU6UJoBDQMH5CRBUIZrNL1-q/view?usp=sharing',
    color: 'success',
  },

];

const travelProposals = [

  {
    name: 'Tentative agreement | March 16, 2022',
    link: 'https://drive.google.com/file/d/1Wc5Sb2AwFIWkgeXBgD7z1cxGTr-duKPy/view?usp=sharing',
    color: 'success',
  },

];

const unionAccessProposals = [

  {
    name: 'Tentative agreement | Sept. 23, 2022',
    link: 'https://drive.google.com/file/d/1blJYtuV9YTSiLO1bb7eUS9iCTO-uewgt/view?usp=sharing',
    color: 'success',
  },

];

const unionSecurityProposals = [

  {
    name: 'Tentative agreement | Sept. 23, 2022',
    link: 'https://drive.google.com/file/d/1nlBYryF5ter8YR3nlSIfwGNMwOdxKGW7/view?usp=sharing',
    color: 'success',
  },

];

const wagesProposals = [

  {
    name: 'Proposal | UAW to UC | April 7, 2022',
    link: 'https://drive.google.com/file/d/1I9DURz1VYaUFUAp8XhheEYgxBdqVEpTC/view?usp=sharing',
    color: 'secondary',

  },
  {
    name: 'Proposal | UC to UAW | June 17, 2022',
    link: 'https://drive.google.com/file/d/1k4eOopEJNFP6PL2pc5BfVCg-HnSy6VaO/view?usp=sharing',
    color: 'secondary',

  },
  {
    name: 'Package | UC to UAW | June 17, 2022',
    link: 'https://drive.google.com/file/d/1n572TTGkWppefvjWzN6qhlPHqOy6thrt/view?usp=sharing',
    color: 'secondary',

  },
  {
    name: 'Proposal | UAW to UC | Sept. 28, 2022',
    link: 'https://drive.google.com/file/d/1N2zawH0mSzq1tZ3VfB9FapDbv5rVpfJw/view?usp=sharing',
    color: 'secondary',

  },
  {
    name: 'Proposal | UC to UAW | Oct. 12, 2022',
    link: 'https://drive.google.com/file/d/1rzK2AgYg-UBrNgYPKxtdcBFSkHju0xuI/view?usp=sharing',
    color: 'secondary',

  },
  {
    name: 'Package | UC to UAW | Oct. 12, 2022',
    link: 'https://drive.google.com/file/d/1WofzmrOi-VV0K7YSbglGyl1LHfUFDAZN/view?usp=sharing',
    color: 'secondary',

  },
  {
    name: 'Package | UAW to UC | Oct. 27, 2022',
    link: 'https://drive.google.com/file/d/1IFN3DPZXJ6bvh1LJb-F8U3cFR7JIzNwl/view?usp=share_link',
    color: 'secondary',

  },
  {
    name: 'Proposal | UC to UAW | Nov. 9, 2022',
    link: 'https://drive.google.com/file/d/1DXQUAyy8AmJBNm0FW9ssNyc9Qre-AjVN/view?usp=share_link',
    color: 'secondary',

  },
  {
    name: 'Proposal | UAW to UC | Nov. 21, 2022',
    link: 'https://drive.google.com/file/d/19bF0M5HyZUzCtGPuR8NF6HhOPEcnpK1p/view',
    color: 'secondary',

  },
  {
    name: 'Package | UC to UAW | Nov. 29, 2022',
    link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/13xBPbmQKEtHQu0NkRp8bEKSYBeS-Zx5f/view?usp=sharing',
    color: 'secondary',

  },
  {
    name: 'Package | UAW to UC | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Dec. 2, 2022',
    link: 'https://drive.google.com/file/d/1exYkh33SCzqQjR2BoRVgn0mHau4OFtb0/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UC to UAW | Dec. 2, 2022',
    link: 'https://drive.google.com/file/d/1BdCcWGtgchfovLgBdC-J50fXu6YEIQRa/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Package | UC to UAW | Dec. 2, 2022',
    link: 'https://drive.google.com/file/d/1-TLFwkLfo3FyXuyedL_7dKXpiCRKcyz9/view?usp=sharing',
    color: 'secondary',
  },
  {
    name: 'Proposal | UAW to UC | Dec. 8, 2022',
    link: 'https://drive.google.com/file/d/186gDPN3kUawkN-a_tNR-rzzC1_NP8O-Q/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Package | UAW to UC | Dec. 8, 2022',
    link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
    color: 'secondary',
  },
  {
    name: 'Tentative agreement A | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1J0sHqoWqdhsGFfXHh33-04QTyn5KY6-O/view?usp=sharing',
    color: 'success',
  },
  {
    name: 'Tentative agreement B | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1AkxOBeinjJGydvspDkxZZMu1J726R16Y/view?usp=sharing',
    color: 'success',
  },
  {
    name: 'Tentative agreement table | Dec. 16, 2022',
    link: 'https://docs.google.com/spreadsheets/d/1YJAEN44f0UwZo1smTpkpCwTv70ZrvQPB/edit?usp=sharing&ouid=109621275669601931014&rtpof=true&sd=true',
    color: 'success',
  },

];

const wagesSideLetterProposal = [

  {
    name: 'Tentative agreement | Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1LD9HCkpmZQOf9c9iM5E7tlb2vUyOe2aM/view',
    color: 'success',
  },

];

const waiverProposals = [

  {
    name: 'Tentative agreement | May 10, 2022',
    link: 'https://drive.google.com/file/d/1nmguHVsho3BCUp7bUXTvT7HbKFHkEPIy/view?usp=sharing',
    color: 'success',
  },

];

const workloadProposals = [

  {
    name: 'Tentative agreement | Nov. 18, 2022',
    link: 'https://drive.google.com/file/d/1o6hpHFy70JI0YtH0UHYLXEeWxB4fOFqi/view?usp=sharing',
    color: 'success',
  },

];

const workspaceMaterialsProposals = [

  {
    name: 'Tentative agreement | March 16, 2022',
    link: 'https://drive.google.com/file/d/1Wc5Sb2AwFIWkgeXBgD7z1cxGTr-duKPy/view?usp=sharing',
    color: 'success',
  },

];

const durationProposals = [

  // {
  //   name: 'Proposal | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1jfwOLhhBxQt7rC70oUIRpfAdJ3sC51OF/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | June 17, 2022',
  //   link: 'https://drive.google.com/file/d/1n572TTGkWppefvjWzN6qhlPHqOy6thrt/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Oct. 12, 2022',
  //   link: 'https://drive.google.com/file/d/1WofzmrOi-VV0K7YSbglGyl1LHfUFDAZN/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1AiLrlBhXjxYVZ84JqQLyKuG91j3SMyXX/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement| Dec. 16, 2022',
    link: 'https://drive.google.com/file/d/1vB76-l70zEYtPWNrUKyEQPyB-DHsoV0y/view?usp=share_link',
    color: 'success',
  },

];

const preambleProposals = [

  // {
  //   name: 'Proposal | UC to UAW | Aug. 23, 2022',
  //   link: 'https://drive.google.com/file/d/1OR1nv7KoOffcJp8v1uGHtzl6LpM9eEe6/view?usp=sharing',
  //   color: 'secondary',

  // },
  // {
  //   name: 'Package | UAW to UC | Nov. 30, 2022',
  //   link: 'https://drive.google.com/file/d/17yOJYlQOi-LxZH8MApUkZDYjSKwdfMQq/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UAW to UC | Dec. 8, 2022',
  //   link: 'https://drive.google.com/file/d/1HFdbfsh3Hv8Rhl4vKIZOyKweaUSxKTjk/view?usp=share_link',
  //   color: 'secondary',
  // },

];

const groundRulesProposals = [

  {
    name: 'Tentative agreement | March 2, 2022',
    link: 'https://drive.google.com/file/d/1e1kOkor0zYLI_mSvDVP-fSvKs8McENh4/view?usp=sharing',
    color: 'success',
  },

];

const appendixFProposals = [

  {
    name: 'Tentative agreement | Oct. 17, 2022',
    link: 'https://drive.google.com/file/d/1wYlVcHvq1o2NM0VbkYS-2SmwxohxSH05/view?usp=sharing',
    color: 'success',
  },

];

const appendixYYProposals = [

  {
    name: 'Tentative agreement | Sept. 21, 2022',
    link: 'https://drive.google.com/file/d/1nuL38C_fC6zhDzfZh19MGrhbAcslAMyX/view?usp=sharing',
    color: 'success',
  },

];

const jointLaborProposals = [
  // {
  //   name: 'Proposal | UAW to UC | March 31, 2022',
  //   link: 'https://drive.google.com/file/d/1_FKPugcLv1mxwBHTGIFafm0mrAgCBntS/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | May 17, 2022',
  //   link: 'https://drive.google.com/file/d/14O8FIoHq9tesRjDjtsBg_J_looRZDmVd/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | July 12, 2022',
  //   link: 'https://drive.google.com/file/d/1j59w6QBGHEtDLBev3_fV3ABViIspHXuq/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Aug. 16, 2022',
  //   link: 'https://drive.google.com/file/d/14T5ba6nVVsds_dTRJqBgrJr9Keu3hjBA/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Aug. 24, 2022',
  //   link: 'https://drive.google.com/file/d/125R9MPypqYK0xk7t4ehS8JYtyVsSvcBs/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Oct. 17, 2022',
  //   link: 'https://drive.google.com/file/d/1r9TcHp_ZMnrXkg3RfH43VCXvIaDOHeN1/view',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Nov. 30, 2022',
    link: 'https://drive.google.com/file/d/1fdFpYPXRkC7soht2W9bAeq44MyCiItsi/view?usp=sharing',
    color: 'success',
  },
];

const berkeleyStaffingProposals = [
  // {
  //   name: 'Proposal | UAW to UC | Oct. 27, 2022',
  //   link: 'https://drive.google.com/file/d/1tdWCJDoHUAVBslgD2OxjvbUvO2O1sMTf/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 17, 2022',
  //   link: 'https://drive.google.com/file/d/15hVscZ-45I58E6RnPgB9zzioIVQCaZzI/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UAW to UC | Nov. 21, 2022',
  //   link: 'https://drive.google.com/file/d/1zMf-8mi5wpib7wJgce4kBMRfPAq0yA8X/view',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1_8osSh8s_9rvF9-JuJE1ceMaCkrdyAdV/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Nov. 29, 2022',
  //   link: 'https://drive.google.com/file/d/1PNV79qWJNgg9OVrnLJqzSrNGHPHkgrVF/view?usp=share_link',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Proposal | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1EdNFaWOG12z1YI36ynhQhe9MTWJkSdU_/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-TLFwkLfo3FyXuyedL_7dKXpiCRKcyz9/view',
  //   color: 'secondary',
  // },
  {
    name: 'Tentative agreement | Dec. 3, 2022',
    link: 'https://drive.google.com/file/d/1EdNFaWOG12z1YI36ynhQhe9MTWJkSdU_/view?usp=sharing',
    color: 'success',
  },

];

const summerFundingSideLetter = [

  // {
  //   name: 'Proposal | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1LVJ4s-Aw9A-cC-wmL-LF0q3UEp3lxvRW/view?usp=sharing',
  //   color: 'secondary',
  // },
  // {
  //   name: 'Package | UC to UAW | Dec. 2, 2022',
  //   link: 'https://drive.google.com/file/d/1-TLFwkLfo3FyXuyedL_7dKXpiCRKcyz9/view?usp=sharing',
  //   color: 'secondary',
  // },
];

const offScalePaymentsSideLetter = [

  // {
  //   name: 'Proposal | UC to UAW | Dec. 4, 2022',
  //   link: 'https://drive.google.com/file/d/1xQ3p8NZ17nZ5RgI5lZ1wPbn5fkoculqH/view?usp=sharing',
  //   color: 'secondary',
  // },

];

const contractExtensionsProposals = [

  {
    name: 'Extension of previous contract to Oct. 1, 2022',
    link: 'https://drive.google.com/file/d/1PbCJgcL9rXyR3e3baRTvWSzId9dCV_j2/view',
    color: 'secondary',
  },

];

export const infoASE = {

  Recognition: {

    proposals: recognitionProposals,
    intro: 'A tentative agreement was reached Nov. 18, 2022, for the recognition article, which recognizes what job titles are counted as ASEs represented by UAW Local 2865.',

  },
  'Appointment notification': {

    proposals: appointmentNotificationProposals,
    intro: 'A tentative agreement was reached Nov. 29, 2022, which outlines how the UC system should notify an ASE of their appointment and with what information.',

  },
  'Appointment security': {

    proposals: appointmentSecurityProposals,
    intro: 'On June 2, 2022, the appointment security article reached a tentative agreement, ensuring some protections for ASEs in the event that a position an ASE accepts is no longer available.',

  },
  'Child care': {

    proposals: childCareProposals,
    intro: 'The UAW Local 2865 and the UC system\'s negotiations for child care reimbursements resulted in a Dec. 16 tentative agreement.',

  },
  Classifications: {

    proposals: classificationsProposals,
    intro: 'The classifications article saw a tentative agreement Nov. 17, 2022. The agreement allows UC campuses to appoint ASEs into positions with the titles specified in the recognition article.',

  },
  'Class sizes': {

    proposals: classSizesProposals,
    intro: 'Proposals from UAW Local 2865 for the class sizes article have asked the UC campuses to post projected classes sizes from each academic department on central campus websites. The Dec. 16 tentative agreement on ASEs\' contract does not include a class sizes article.',

  },
  'Community safety': {

    proposals: communitySafetyProposals,
    intro: 'This article has one Sept. 21, 2022, proposal from the UAW Local 2865 bargaining team. This proposal asked the UC system to defund UC police departments’ budgets and refrain from calling law enforcement to UC campuses, among other demands. The Dec. 16 tentative agreement on ASEs\' contract does not include a community safety article.',

  },
  'Defined contribution and university retirement plans': {

    proposals: retirementProposals,
    intro: 'The UC system and the bargaining unit tentatively agreed on a proposal to this article, setting up a policy for the UC system’s contribution to ASEs’ retirement plans.',
  },
  Definitions: {

    proposals: definitionsProposals,
    intro: 'On March 16, 2022, a tentative agreement was reached on the definitions article, along with some other articles, as part of a package of proposals that maintained the policy from previous contracts.',

  },
  'Discipline and dismissal': {

    proposals: disciplineProposals,
    intro: 'UAW Local 2865 and the UC system reached a tentative agreement on discipline and dismissal June 17, 2022.',

  },
  'Emergency layoff': {

    proposals: emergencyLayoffProposals,
    intro: 'Maintaining the previous contract between the UC system and the union for emergency layoffs, a tentative agreement was reached for this article March 16, 2022, as part of a package of proposals.',

  },
  'Employment files and evaluations': {

    proposals: filesProposals,
    intro: 'This April 19, 2022 tentative agreement defines employment files and evaluations and how ASEs may access them.',

  },
  'Fee remission': {

    proposals: feeRemissionProposals,
    intro: 'Fee remission is offered to graduate student instructors, graduate student readers, readers and tutors to offset fees, including those for tuition, health insurance, student services and more, according to the Berkeley Graduate Division website. Policy for ASEs\' fee remission was tentatively agreed upon Dec. 16.',

  },
  'Grievance and arbitration': {

    proposals: grievanceProposals,
    intro: 'A tentative agreement has been reached for the grievance and arbitration article.',

  },
  'Health and safety': {

    proposals: healthSafetyProposals,
    intro: 'Both parties arrived at a tentative agreement regarding the health and safety article April 19, 2022.',

  },
  'Health benefits': {

    proposals: healthBenefitsProposals,
    intro: 'Policy for ASEs’ health benefits reached a tentative agreement Dec. 16.',

  },
  Holidays: {

    proposals: holidaysProposals,
    intro: 'UAW Local 2865 and the UC system tentatively agreed upon a proposal March 2, 2022, regarding holidays, excusing ASEs from many responsibilities on designated holidays.',

  },
  Housing: {

    proposals: housingProposals,
    intro: 'The Dec. 16 tentative agreement on ASEs\' contract does not include a housing article.',

  },
  'International scholars and immigrant support': {

    proposals: internationalProposals,
    intro: 'Negotiations for this article cover UC-provided supports for international students and more.',

  },
  'Labor management meetings': {

    proposals: laborManagementProposals,
    intro: 'The parties tentatively agreed on a proposal for labor management meetings March 16, 2022, as part of a package of proposals that maintained the policy from previous contracts.',

  },
  Leaves: {
    proposals: leavesProposals,
    intro: 'Negotiations on military, pregnancy, medical and other leaves resulted in a tentative agreement.',

  },
  'Management and academic rights': {

    proposals: academicRightsProposals,
    intro: 'Policy for the management and academic rights article was tentatively agreed upon.',

  },
  'No strikes': {

    proposals: noStrikesProposals,
    intro: 'A proposal from the UC system dated April 19, 2022, demanded that there should be “no strikes, including sympathy strikes, stoppages or interruptions of work.” Negotiation continues for this article.',
  },
  'Nondiscrimination in employment': {

    proposals: nondiscriminationProposals,
    intro: 'On Sept. 28, 2022, a proposal for this article was tentatively agreed upon as part of a package with the article on respectful workplace environments.',

  },
  'Parking and transit': {

    proposals: parkingTransitProposals,
    intro: 'This Nov. 30, 2022 tentative agreement entitles ASEs to UC-provided transit system passes, monthly public transit allowances, e-bike discounts and more.',

  },
  'Peer-led trainings': {

    proposals: peerLedTrainingProposals,
    intro: 'The Dec. 16 tentative agreement on ASEs\' contract does not include a peer-led trainings article.',

  },
  Posting: {

    proposals: postingProposals,
    intro: 'According to the April 19, 2022, tentative agreement for the posting article, the UC system should post any available ASE positions on a central campus website.',

  },
  'Reasonable accommodations': {

    proposals: reasonableAccommodationsProposals,
    intro: 'Proposals for the reasonable accommodations article have concerned the extent and grounds for access accommodations afforded to ASEs with disabilities. Both parties came to a tentative agreement on reasonable accommodations for ASEs Nov. 30, 2022.',

  },
  'Past practices': {

    proposals: pastPracticesProposals,
    intro: 'As part of a package of proposals dated May 10, 2022, the past practices article was retracted, and both the UC system and UAW Local 2865 tentatively agreed on a proposal for the waiver article.',

  },
  'Access needs side letter': {

    proposals: accessNeedsProposals,
    intro: 'The access needs side letter concerns resources and strategies regarding accessibility in ASEs’ workplaces. This side letter is in negotiation.',

  },
  'Relocation benefit': {

    proposals: relocationBenefitProposals,
    intro: 'The one standing proposal for this article is from UAW Local 2865. It bargains for a $5,000 relocation benefit for doctoral students looking to move close to their location of their work.  The Dec. 16 tentative agreement on ASEs\' contract does not include a relocation benefit article.',

  },
  'Respectful work environment': {

    proposals: respectfulProposals,
    intro: 'On Sept. 28, 2022, a proposal for this article was tentatively agreed upon as part of a package with the article on nondiscrimination in employment.',

  },
  Severability: {

    proposals: severabilityProposals,
    intro: 'UAW Local 2865 and the UC system tentatively agreed on this article March 16 as part of a package of proposals that maintained the language from the previous contract.',

  },
  'Summer session': {

    proposals: summerSessionProposals,
    intro: 'A tentative agreement for this article was reached Nov. 29, 2022.',

  },
  'Training and orientation': {

    proposals: trainingOrientationProposals,
    intro: 'A tentative agreement on the training and orientation article was signed by representatives from UAW Local 2865 and the UC system.',

  },
  Travel: {

    proposals: travelProposals,
    intro: 'The travel article saw a tentative agreement March 16, 2022, as part of a package of proposals that maintained the policy from the parties\' previous contract.',

  },
  'Union access and rights': {

    proposals: unionAccessProposals,
    intro: 'A Sept. 23, 2022, tentative agreement on union access and rights was signed by representatives from UAW Local 2865 and the UC.',

  },
  'Union security': {

    proposals: unionSecurityProposals,
    intro: 'By the Sept. 23, 2022, tentative agreement on union security, the UC system will provide a list of ASEs by name and department to the union. The agreement includes guidelines for fees and the union membership election form for new ASEs – which will be accompanied by Appendix YY.',

  },
  Wages: {

    proposals: wagesProposals,
    intro: 'The UC system and UAW Local 2865 have come to a tentative agreement on yearly salary increases and base pay for both graduate and undergraduate ASEs, but the entire proposal history for this article will remain listed. The Dec. 16 tentative agreement contains a pay table and multiple sections.',

  },
  Waiver: {

    proposals: waiverProposals,
    intro: 'A tentative agreement on the waiver article was reached May 10, 2022.',

  },
  Workload: {

    proposals: workloadProposals,
    intro: 'The Nov. 18, 2022, tentative agreement on the workload article established hourly workloads for teaching assistants, readers, tutors and instructors of record. The agreement also guides the UC system’s response to ASEs who are about to go over their hourly workload for the day, week or term.',

  },
  'Workspace materials and instructional support': {

    proposals: workspaceMaterialsProposals,
    intro: 'A March 16, 2022, tentative agreement maintains the parties\' previous contract agreement on workspace materials and instructional support, which was passed as part of a package of proposals.',

  },
  Duration: {

    proposals: durationProposals,
    intro: 'The duration article of the 2018 contract between UAW Local 2865 and the UC system originally stated that it would last until June 30, 2022. The union and the UC system tentatively agreed this new contract should last terminate May 31, 2025.',

  },
  Preamble: {

    proposals: preambleProposals,
    intro: 'The proposal history for the preamble consists of one proposal from the UC system, but the Dec. 16 tentative agreement does not include a preamble.',

  },
  'Ground rules': {

    proposals: groundRulesProposals,
    intro: 'On March 2, 2022, the two parties tentatively agreed upon ground rules regarding conduct at bargaining meetings, tentative agreements and more.',

  },
  'Appendix F': {

    proposals: appendixFProposals,
    intro: 'The Oct. 17, 2022, tentative agreement on Appendix F specifies ASEs\' participation in the UC system\'s Retirement Savings Program.',

  },
  'Appendix YY': {

    proposals: appendixYYProposals,
    intro: 'On Sept. 21, 2022, the union and the UC system tentatively agreed on Appendix YY — which is sent out to new ASEs along with a union membership election form. Appendix YY states that the UC system neither discourages or encourages UAW Local 2865 membership.',

  },
  'Joint labor management committee': {

    proposals: jointLaborProposals,
    intro: 'Proposals for other side letters and articles have listed objectives for this committee on workplace accessibility. A tentative agreement was reached Nov. 30, 2022, setting the goals and agenda of the joint labor management committee.',

  },
  'Berkeley staffing side letter': {

    proposals: berkeleyStaffingProposals,
    intro: 'The Oct. 27, 2022, union proposal for this side letter aimed to increase staffing for courses within the statistics, data science and electrical engineering and computer sciences departments at UC Berkeley.',

  },
  'Extension of previous contract': {

    proposals: contractExtensionsProposals,
    intro: 'The previous contract between the UC system and the UAW Local 2865 was set to expire June 30, 2022. That contract — which barred the union from authorizing strikes — was only extended to Oct. 1, 2022.',

  },
  'Summer funding side letter': {

    proposals: summerFundingSideLetter,
    intro: 'There was one UC proposal regarding this side letter, but it did not make into the tentative contract agreement.',

  },
  'Off-scale payments side letter': {

    proposals: offScalePaymentsSideLetter,
    intro: 'There is one UC proposal regarding this side letter, but it did not make into the tentative contract agreement.',

  },
  'Wages side letter': {

    proposals: wagesSideLetterProposal,
    intro: 'Language for this side letter was tentatively agreed upon Dec. 16.',
  },

};
